module.exports = __webpack_public_path__ + "static/media/29EUNOG5.121c2536.jpg";